import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  connect() {
    this.targetHeight;
    this.targetDOMNode = this.window.document.querySelector(
      this.data.get('target'),
    );

    this.window.addEventListener('resize', this.sendPostMessage);
    this.window.document.addEventListener('turbo:load', this.sendPostMessage);
  }

  sendPostMessage = () => {
    if (this.targetHeight !== this.targetDOMNode.offsetHeight) {
      this.targetHeight = this.targetDOMNode.offsetHeight;
      this.window.parent.postMessage(
        {
          frameHeight: this.targetHeight,
        },
        '*',
      );
    }
  };

  disconnect() {
    this.window.removeEventListener('resize', this.sendPostMessage);
    this.window.document.removeEventListener(
      'turbo:load',
      this.sendPostMessage,
    );
  }
}
